import {mapState} from "vuex";

export default {
  props: {
    tooltipKey: {
      type: String,
    }
  },
  computed: {
    ...mapState({
      tooltips: state => state.tooltips.all,
    }),
    toolTip() {
      if (Object.keys(this.tooltips).length === 0) return;

      let tooltip = this.tooltips[this.tooltipKey];

      if (!tooltip) {
        tooltip = null;
      }

      return tooltip;
    }
  }
}
